module.exports = __webpack_public_path__ + "static/media/natale.d2df5543.png";


//////////////////
// WEBPACK FOOTER
// ./src/include/images/natale.png
// module id = 203
// module chunks = 0